import script from "./BrandView.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandView.vue?vue&type=script&setup=true&lang=js"

import "./BrandView.vue?vue&type=style&index=0&id=f078fd74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f078fd74"]])

export default __exports__